import $ from "jquery";
import $hub from "../../shared/hub";
import helpers from "../../Shared/helpers/index";

// broadcast the changed event
const broadcastChangeEvent = () => $hub.trigger("toggle.change");

function init() {
    $(".person").each(function () {
        if ($(this).hasClass("person--accordion")) {
            $(this)
                .find(".person__title, .person__item .js-close")
                .on("click", function (e) {
                    const target = e.target;
                    const isLink = target.tagName === "A";
                    if (!isLink) {
                        const theItem = $(this).parents(".person__item");

                        theItem
                            .find(".person__ekstra-info")
                            .toggleClass("active")
                            .slideToggle(function () {
                                if ($(document).width() > 767) {
                                    let matchheight = $(this)
                                        .find(".person__ekstra-info-auther")
                                        .outerHeight();
                                    matchheight =
                                        matchheight >
                                        $(this)
                                            .find(
                                                ".person__ekstra-info-details",
                                            )
                                            .outerHeight()
                                            ? matchheight
                                            : $(this)
                                                  .find(
                                                      ".person__ekstra-info-details",
                                                  )
                                                  .outerHeight();

                                    $(this)
                                        .find(
                                            ".person__ekstra-info-auther, .person__ekstra-info-details",
                                        )
                                        .css("height", matchheight);
                                }
                                broadcastChangeEvent();
                            });

                        if (!helpers.isMobileDevice())
                            helpers.scrollToElement(
                                theItem.parents(".accordion__item"),
                                300,
                                100,
                            );

                        return false;
                    }
                    return true;
                });
        } else {
            $(this)
                .find(".person__title, .person__item .js-close")
                .on("click", function (e) {
                    const target = e.target;
                    const isLink = target.tagName === "A";
                    if (!isLink) {
                        const theItem = $(this).parents(".person__item");

                        const nugot =
                            $(document).width() < 767
                                ? 0
                                : theItem
                                      .find("> .person__images")
                                      .outerHeight() + 15;
                        const topPos = theItem.position().top + nugot;

                        theItem
                            .find(".person__ekstra-info")
                            .css("top", topPos)
                            .toggleClass("active")
                            .slideToggle(function () {
                                if ($(document).width() > 767) {
                                    let matchheight = $(this)
                                        .find(".person__ekstra-info-auther")
                                        .outerHeight();
                                    matchheight =
                                        matchheight >
                                        $(this)
                                            .find(
                                                ".person__ekstra-info-details",
                                            )
                                            .outerHeight()
                                            ? matchheight
                                            : $(this)
                                                  .find(
                                                      ".person__ekstra-info-details",
                                                  )
                                                  .outerHeight();

                                    $(this)
                                        .find(
                                            ".person__ekstra-info-auther, .person__ekstra-info-details",
                                        )
                                        .css("height", matchheight);
                                }

                                $(this)
                                    .parents(".owl-stage-outer")
                                    .css(
                                        "height",
                                        $(this)
                                            .parents(".owl-item.active")
                                            .height(),
                                    );
                                broadcastChangeEvent();
                            });

                        return false;
                    }
                    return true;
                });
        }
    });

    function debounce(func, wait = 20, immediate = true) {
        let timeout;

        return function () {
            let context = this,
                args = arguments;

            const later = function () {
                timeout = null;

                if (!immediate) {
                    func.apply(context, args);
                }
            };

            const callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);

            if (callNow) {
                func.apply(context, args);
            }
        };
    }

    function toggleAccordion() {
        const $this = $(this);
        const target = $this.data("togglerObj");
        const $button = $this.closest(".company-place__item");

        if ($button.hasClass("active")) {
            $button.removeClass("active");
        } else {
            $(".company-place__item.active").removeClass("active");
            $button.addClass("active");
        }

        if ($(".additional-service__toggle.activet").length) {
            if ($(`[data-toggler-id=${target}]`).hasClass("activet")) {
                $(".additional-service__toggle.activet")
                    .toggleClass("activet")
                    .slideToggle(broadcastChangeEvent);
            } else {
                $(".additional-service__toggle.activet")
                    .toggleClass("activet")
                    .slideToggle(function () {
                        $(`[data-toggler-id=${target}]`)
                            .toggleClass("activet")
                            .slideToggle(broadcastChangeEvent);
                    });
            }
        } else {
            $(`[data-toggler-id=${target}]`)
                .toggleClass("activet")
                .slideToggle(broadcastChangeEvent);
        }

        return false;
    }

    $(".additional-service__item .js-toggle-btn").on(
        "click",
        debounce(toggleAccordion, 200, true),
    );
    $(".additional-service .company-place__item").each(function () {
        $(this).css("height", this.clientHeight);
    });

    // Author

    $(".js-author").on("click", ".js-author-details-toggle", function (e) {
        e.preventDefault();
        const details = $(e.delegateTarget).find(".js-author-details");
        details.toggleClass("active");
        broadcastChangeEvent();
    });
}

export default {
    init,
};
